import { render, staticRenderFns } from "./ViewAllNotificationComponent.vue?vue&type=template&id=51106a82&"
import script from "./ViewAllNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./ViewAllNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports